import { render, staticRenderFns } from "./userInfoForm.vue?vue&type=template&id=95821d5c&scoped=true&"
import script from "./userInfoForm.vue?vue&type=script&lang=js&"
export * from "./userInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./userInfoForm.vue?vue&type=style&index=0&id=95821d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95821d5c",
  null
  
)

export default component.exports